/**
 * 数値をカンマ区切りでフォーマット
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 数値をカンマ区切りの読みやすい表記に整形する
 * @graph-connects none
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) return '0';
  return value.toLocaleString('ja-JP');
}

/**
 * 日付文字列を短い形式にフォーマット（M/D）
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 日付文字列をグラフ向けの短い表記に整形する
 * @graph-connects none
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return `${String(date.getMonth() + 1)}/${String(date.getDate())}`;
}

/**
 * ミリ秒を読みやすい滞在時間にフォーマット
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 滞在時間のミリ秒を読みやすい時間表記に整形する
 * @graph-connects none
 */
export function formatDuration(ms: number): string {
  if (ms < 1000) return `${String(Math.round(ms))}ms`;
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  return `${String(minutes)}m ${String(remainingSeconds)}s`;
}

/**
 * デルタパーセントをフォーマット（+/-記号付き）
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 前期比の増減率を符号付きパーセント表記に整形する
 * @graph-connects none
 */
export function formatDeltaPercent(delta: number): string {
  const sign = delta > 0 ? '+' : '';
  return `${sign}${delta.toFixed(1)}%`;
}

/**
 * デルタの方向を判定
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 増減値から上昇・下降・横ばいの方向を判定する
 * @graph-connects none
 */
export function getDeltaDirection(delta: number): 'positive' | 'negative' | 'neutral' {
  if (delta > 0) return 'positive';
  if (delta < 0) return 'negative';
  return 'neutral';
}
